import { PRODUCT_INFO_SERVICE_URL } from 'product/constants/constants'
import { env } from 'utils/envManager'

type GetClientProductInfoParams = {
	countryISO: string
	languageISO: string
	productId: string
}

export const getClientProductInfoUrl = ({
	productId,
	countryISO,
	languageISO,
}: GetClientProductInfoParams) => {
	const searchParams = new URLSearchParams({
		countryIso: countryISO,
		languageIso: languageISO,
		channelId: env.NEXT_PUBLIC_CHANNEL,
		productId,
	})

	const url = new URL(
		PRODUCT_INFO_SERVICE_URL,
		env.NEXT_PUBLIC_ORCHESTRATOR_DOMAIN
	)

	url.search = searchParams.toString()

	return url.href
}
